import type { Conversation } from '.';
import { Dialog } from './conservation.ruleset';

export const conversationModifiers = ({
  conversation,
}: Conversation.MutableState) => ({
  incrementTimesSeen(dialogId: Dialog['id']) {
    if (!conversation.dialogs[dialogId]) {
      conversation.dialogs[dialogId] = {
        timesSeen: 0,
      };
    }

    conversation.dialogs[dialogId].timesSeen += 1;
  },

  saveAnswer(answer: { answerVar: string; key?: string; value: string }) {
    const { answerVar, ...answerProps } = answer;
    conversation.answers[answerVar] = answerProps;
  },
});
